import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20manga%20style%20illustration%20with%20vibrant%20comic%20book%20elements%2C%20exploding%20action%20lines%20and%20speed%20effects%2C%20silhouettes%20of%20various%20manga%20characters%20in%20dynamic%20poses%2C%20warm%20orange%20and%20deep%20red%20gradient%20background%2C%20stylized%20Japanese%20and%20Chinese%20comic%20aesthetic%2C%20cinematic%20composition%2C%20high%20contrast&width=1600&height=700&seq=hero-manga-bg&orientation=landscape"
          alt="古古漫画网 - 热门漫画推荐"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
          <span className="text-xs md:text-sm text-background-50 font-medium">每日更新 200+ 部漫画</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
          追更连载，<span className="text-primary-300">免费全集</span>下拉式阅读
        </h1>
        <p className="text-sm md:text-base text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          国漫、日漫、韩漫热门漫画一网打尽，每日实时更新，
          人气漫画大全尽在古古漫画网
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/lianzai"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            立即追更
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/wanjie"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg backdrop-blur-sm border border-background-50/20 transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            完结漫画
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-8 text-xs text-background-300">
          <div className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">500万+</span>
            <span>注册用户</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">20000+</span>
            <span>漫画作品</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">每日200+</span>
            <span>实时更新</span>
          </div>
        </div>
      </div>
    </section>
  );
}